/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useEffect } from "react";
import { View } from "react-native";
import MetricMetadataTable from "./MetricMetadataTable";
import MetricTable from "./MetricTable";
import DropCSVReader from "./DropCSVReader";
import DataModal from "./DataModal";

import { useDispatch, useSelector } from "react-redux";
import { ActionCreators } from "actions";
import { RootState } from "store/types";

import { Text } from "UpduoLibrary";
import { callApi } from "config/UpduoService";

import { skaleMainBlue } from "config/UpduoColors";

export default function PerformanceRoute() {
  const dispatch = useDispatch();
  const authToken = useSelector((state: RootState) => state.authToken);
  const uploadedCsvDataList = useSelector(
    (state: RootState) => state.uploadedCsvDataList
  );

  useEffect(() => {
    _handleGetMetricMetadataList();
    _handleGetMetricList();
  }, [authToken]);

  const _handleGetMetricMetadataList = () => {
    callApi(
      "getMetricMetadataList",
      undefined,
      (responseJson) => {
        const metricMetadataList = responseJson;
        dispatch(ActionCreators.setMetricMetadataList(metricMetadataList));
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const _handleGetMetricList = () => {
    callApi(
      "getMetricList",
      undefined,
      (responseJson) => {
        const metricList = responseJson;
        dispatch(ActionCreators.setMetricList(metricList));
      },
      (error) => {
        console.log(error);
      }
    );
  };

  return (
    <View>
      <View
        style={{
          margin: 30,
          maxWidth: 2000,
          minWidth: 1200,
          alignSelf: "center",
        }}
      >
        <View>
          <Text style={{ fontSize: 30, fontWeight: "bold" }}>
            {"Performance"}
          </Text>
        </View>
        <View style={{ marginTop: 30 }}>
          <Text style={{ fontSize: 20, paddingBottom: 10 }}>
            {"Upload latest employee performance CSV file"}
          </Text>
          <View
            style={{
              borderWidth: 2,
              borderColor: skaleMainBlue,
              borderStyle: "dashed",
              borderRadius: 10,
            }}
          >
            <DropCSVReader />
          </View>
        </View>
        <View style={{ marginTop: 30 }}>
          <Text style={{ fontSize: 20, paddingBottom: 10 }}>{"History"}</Text>
          <MetricMetadataTable />
        </View>
        <View style={{ marginTop: 30 }}>
          <Text style={{ fontSize: 20, paddingBottom: 10 }}>{"Metrics"}</Text>
          <MetricTable />
        </View>
        <DataModal
          dataInfo={uploadedCsvDataList}
          onClose={() => {
            dispatch(ActionCreators.setUploadedCsvDataList([]));
            _handleGetMetricMetadataList();
            _handleGetMetricList();
          }}
          onDelete={() => {
            dispatch(ActionCreators.setUploadedCsvDataList([]));
          }}
        />
      </View>
    </View>
  );
}
